import { updateState } from './admin-globals.js';
import { showToast } from './admin-ui-base.js';
import { loadCatalog } from './catalog-api.js';

export function getToken() { return localStorage.getItem('raptv_token'); }

export function authHeaders() {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = 'Bearer ' + token;
  return headers;
}

export async function checkLogin() {
  const email = document.getElementById('login-email').value.trim();
  const pass = document.getElementById('login-pass').value;
  try {
    const res = await fetch('/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password: pass })
    });
    if (res.ok) {
      const data = await res.json();
      localStorage.setItem('raptv_token', data.token);
      updateState('currentUser', data.user);
      document.getElementById('login-gate').style.display = 'none';
      onLoggedIn();
    } else {
      const err = document.getElementById('login-error');
      err.style.opacity = '1';
      document.getElementById('login-pass').value = '';
      setTimeout(() => err.style.opacity = '0', 2000);
    }
  } catch(e) {
    showToast('ERROR DE CONEXIÓN', true);
  }
}

export async function checkAuth() {
  const token = getToken();
  if (!token) { showLoginGate(); return; }
  try {
    const res = await fetch('/auth/me', { headers: { 'Authorization': 'Bearer ' + token } });
    if (res.ok) {
      const user = await res.json();
      updateState('currentUser', user);
      document.getElementById('login-gate').style.display = 'none';
      onLoggedIn();
    } else {
      localStorage.removeItem('raptv_token');
      showLoginGate();
    }
  } catch(e) {
    showLoginGate();
  }
}

export function showLoginGate() {
  const el = document.getElementById('login-gate');
  if (el) el.style.display = 'flex';
}

export function logout() {
  localStorage.removeItem('raptv_token');
  updateState('currentUser', null);
  updateState('catalog', []);
  updateState('selectedChannel', 0);
  document.getElementById('sidebar-channels').innerHTML = '';
  document.getElementById('main-content').innerHTML = '<div class="no-channel"><div>◄ SELECCIONA UN CANAL</div></div>';
  showLoginGate();
}

export function onLoggedIn() {
  // Se asume que currentUser ya está en Globals
  import('./admin-globals.js').then(G => {
    const user = G.currentUser;
    if (user) {
      document.getElementById('header-username').textContent = user.username.toUpperCase();
      const badge = document.querySelector('.admin-badge');
      if (user.is_admin) {
        const btnUsers = document.getElementById('btn-users');
        if (btnUsers) btnUsers.style.display = '';
      } else {
        badge.textContent = 'VIP';
        badge.classList.add('vip');
      }
    }
    loadCatalog();
  });
}
